import { Guid } from "guid-typescript";

import { ValidationIssueSeverity } from "infrastructure/validation";
import { extractApiErrorMessageContent } from "ui/shared/models/common";

import { ITranslationUploadResponseItem } from "./TranslationUpload.api";
import { ITranslationUploadValidationIssue } from "./TranslationUpload.state";

export const getValidationIssues = (response: ITranslationUploadResponseItem[]): ITranslationUploadValidationIssue[] => {
  return (
    response &&
    response.map<ITranslationUploadValidationIssue>(e => {
      return {
        uniqueId: e.uniqueId ? e.uniqueId : Guid.raw(),
        messageId: e.messageId,
        messageTranslation: e.messageTranslation,
        locale: e.locale,
        industry: e.industry,
        validationIssue: {
          severity: ValidationIssueSeverity.Error,
          message: extractApiErrorMessageContent(e.error)
        }
      };
    })
  );
};
